<template>
  <div class="promotions">
    <div class="button-container" style="width: 100%">
      <button
        class="btn btn-tabs"
        v-for="(tab, i) in filteredTabs"
        :key="i"
        :class="{ active: isActive(tab) }"
        @click="navigateTo(tab)"
      >
        {{ $t(tab.name) }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'PromotionTabNavigation',
  data() {
    return {
      currentTab: null,
    }
  },
  props: {
    tabs: {
      type: Array,
      required: false,
      default: () => [
        { name: 'Activity', link: '/promotion/activity' },
        // { name: 'Rebates', link: '/promotion/rebates' },
        // { name: 'VIP', link: '/promotion/vip' },
        { name: 'History', link: '/promotion/history' },
        { name: 'Cover', link: '/promotion/cover' },
      ],
    },
  },
  computed: {
    ...mapState({
      userInfo: (store) => store.auth.userInfo,
    }),
    filteredTabs() {
      if (!this.userInfo.id) {
        return this.tabs.filter((tab) => tab.name != 'Rebates')
      }

      return this.tabs
    },
  },
  methods: {
    navigateTo(tab) {
      this.currentTab = tab
      this.$router.push({ path: tab.link })
    },
    isActive(tab) {
      if (this.$route.fullPath.includes(tab.link)) return true
      return this.currentTab === tab
    },
  },
  mounted() {
    const currentPath = this.$route.path
    this.currentTab = this.tabs.find((tab) => tab.link === currentPath)
  },
}
</script>

<style lang="less" scoped>
.button-container {
  display: flex !important;
  justify-content: space-between !important;
  width: 100%;
}

.btn.btn-tabs {
  flex: 1;
  text-align: center;
  padding: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Promotion/tabNavigation.vue